// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from editor-text-bold.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function EditorTextBoldIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M8.661 16c.805 0 1.536-.117 2.193-.351a4.953 4.953 0 0 0 1.69-.993c.47-.428.831-.947 1.081-1.557s.375-1.287.375-2.03c0-.29-.038-.588-.114-.893a4.123 4.123 0 0 0-.325-.87 3.937 3.937 0 0 0-.495-.754 4.412 4.412 0 0 0-.604-.597c-.17-.126-.17-.264 0-.412.381-.335.699-.772.953-1.311.254-.54.382-1.062.382-1.568 0-.64-.132-1.244-.394-1.813a4.628 4.628 0 0 0-1.081-1.484c-.458-.42-1-.753-1.627-.999A5.531 5.531 0 0 0 8.66 0H2.52a.534.534 0 0 0-.362.14A.415.415 0 0 0 2 .456v15.086c0 .119.053.225.159.318a.534.534 0 0 0 .362.139h6.14zm-.127-9.852H5.826c-.17 0-.254-.075-.254-.223V3.437c0-.157.085-.235.254-.235h2.708c.45 0 .847.145 1.195.435.347.29.521.633.521 1.027 0 .394-.174.74-.521 1.038a1.784 1.784 0 0 1-1.195.446zm0 6.65H5.826c-.17 0-.254-.075-.254-.223v-2.99c0-.157.085-.235.254-.235h2.708c.56 0 1.004.177 1.335.53.33.353.495.75.495 1.188 0 .454-.165.856-.495 1.205-.33.35-.776.525-1.335.525z"
        />
      </g>
    </svg>
  );
}
